export default "__VITE_ASSET__Ct75tZx1__"